import { UsageRegionTarget } from 'todistukset-common/src/vtj/UsageRegionTarget.enum'
import { UsageRegionReceiver } from 'todistukset-common/src/vtj/UsageRegionReceiver.enum'
import { ApostilleCountries } from 'todistukset-common/src/vtj/ApostilleCountries.enum'
import { isCountryInApostilleByCode } from 'todistukset-common/src/vtj/country.util'
import { TodistusStoreForm } from 'todistukset-common/src/vtj/types/form-types.type'

export const checkIfApostilleIsAvailable = ({
  usageRegion,
}: {
  usageRegion: TodistusStoreForm['usageRegion']
}): boolean => {
  return (
    usageRegion.countryKoodistoCode !== ApostilleCountries.FINLAND &&
    usageRegion.target !== UsageRegionTarget.EU_AUTHORITY &&
    usageRegion.receiver !== UsageRegionReceiver.TARGET_COUNTRY_AUTHORITY &&
    isCountryInApostilleByCode(usageRegion.countryKoodistoCode)
  )
}
